// Laravel boolean validation accepts only: true, false, 1, 0, "1", "0"
// FormData.append converts JS boolean true → "true" which Laravel rejects.
// Explicitly map boolean → "1"/"0" to stay compatible.
export default (obj) => {
  const formData = new FormData()
  for (let key in obj) {
    const value = obj[key]
    if (Array.isArray(value)) {
      formData.append(key, value)
    } else if (typeof value === 'boolean') {
      formData.append(key, value ? '1' : '0')
    } else {
      formData.append(key, value)
    }
  }
  return formData
}
